const MessageTypes = Object.freeze({
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
});

export default MessageTypes;
